<script setup lang="ts">
const props = defineProps<{
  imageSizeClass: string
}>()
</script>

<template>
  <a
    class="tw-inline-block"
    href="https://itunes.apple.com/us/app/riser-motorcycle-navigation/id1087005682?mt=8"
    target="_blank"
  >
    <img :class="props.imageSizeClass" alt="Download on the App Store" src="/apple_app_store.svg" />
  </a>
</template>
